// PANTALLA 0 — El Lobby de Bienvenida (el enganche)
// Copy: ../lobbyContent.js → LOBBY_WELCOME
//
// Es «/»: la primera impresión de NSL y, en cuanto se conecte el dominio, su
// cara pública. No pide nada, solo se presenta — pero se presenta prometiendo
// algo, que es lo que le faltaba.
//
// ── QUÉ CAMBIÓ EL 24-09-2026 ────────────────────────────────────────────────
// Era un splash: un logo enorme al centro, un saludo pintado con un degradado
// amarillo-a-verde que sobre fondo claro salía color aceituna, y una frase de
// cuerpo pequeño. Rob: «un amarillo que no es el de NSL, un verde espantoso,
// unas letras sin diseño… no impacta a nadie».
//
// La jerarquía se invirtió: el logo presenta (más pequeño) y el TITULAR habla,
// con el recurso que sí funciona en la página de empresas —peso negro de Inter
// y la palabra clave dentro de un bloque de color—, pero en el amarillo real
// de la marca. El verde neón se queda donde le corresponde: marcando aciertos
// dentro del diagnóstico.
import { LOBBY_WELCOME } from '../lobbyContent';
import { useObTheme } from '../useObTheme';

export default function LobbyWelcome({ onNext }) {
    // El logo tiene dos versiones y la correcta depende del fondo, así que sigue
    // al tema en vez de quedar fijo en la variante oscura.
    const isDark = useObTheme() === 'dark';

    return (
        <div className="ob-screen ob-lobby">
            <p className="ob-lobby-chapa">{LOBBY_WELCOME.chapa}</p>

            <p className="ob-lobby-welcome-to">
                {LOBBY_WELCOME.greeting} {LOBBY_WELCOME.headline}
            </p>

            <img
                src="/logo-dark.png"
                alt={LOBBY_WELCOME.brandAlt}
                className="ob-lobby-logo"
            />

            {/* El único <h1> de la pantalla: antes el titular era el logo, que
                para un lector de pantalla y para Google no dice nada. */}
            <h1 className="ob-lobby-titular">
                <span className="ob-lobby-titular-linea">{LOBBY_WELCOME.titularLinea}</span>
                <span className="ob-lobby-bloque">{LOBBY_WELCOME.titularBloque}</span>
            </h1>

            <p className="ob-lobby-tagline">{LOBBY_WELCOME.subheadline}</p>

            <div className="ob-actions ob-lobby-actions">
                <button type="button" className="ob-btn ob-btn-marca ob-btn-lg" onClick={onNext}>
                    {LOBBY_WELCOME.cta}
                </button>
            </div>

            <ul className="ob-lobby-pruebas">
                {LOBBY_WELCOME.pruebas.map((p) => (
                    <li key={p.text} className="ob-lobby-prueba">
                        <span className="ob-lobby-prueba-icono" aria-hidden="true">{p.icon}</span>
                        {p.text}
                    </li>
                ))}
            </ul>
        </div>
    );
}
